import React from 'react';

import { useCompleteModal } from 'modal.react.js';

import * as magicImportApi from 'api/magicImport';
import { AModal } from 'components/shared/AModal';
import Button from 'components/shared/Button';
import Icon from 'components/shared/Icon';
import ImageIcon from 'components/shared/Icon/icons/Image';
import MapTrifoldIcon from 'components/shared/Icon/icons/MapTrifold';
import Text from 'components/shared/Typography/Text';

import s from './MagicImportStatusModal.module.css';

type Props = {
  importId?: number;
  onClose?: () => void;
};

export const MagicImportCompletedModal = (props: Props) => {
  const modalControl = useCompleteModal();

  const handleClose = async () => {
    try {
      if (props.importId) {
        await magicImportApi.markAsInserted(props.importId);
      }
    } catch (error) {
      console.error('Failed to mark magic import as inserted:', error);
    }

    props.onClose?.();
    modalControl.success(null);
  };

  return (
    <AModal
      header="Your Magic Import is Complete!"
      isOpen={true}
      footer={<MagicImportCompletedModalFooter submitForm={handleClose} />}
      size="lg"
      onClose={handleClose}
      isCloseOnEsc={false}
      contentClassName={s.modalContent}
    >
      <div className={s.content}>
        <div className={s.imageWrapper}>
          <img
            src="https://safariportal-media-production.s3.us-east-1.amazonaws.com/design_2.gif"
            alt="Magic Import Completed"
            className={s.slideImage}
          />
        </div>
        <div className={s.textContent}>
          <Text type="brandon" className={s.title}>
            Your PDF has been successfully imported!
          </Text>
          <div className={s.whatsNext}>
            <Text type="brandon" className={s.whatsNextTitle}>
              What's next?
            </Text>
            <ul className={s.whatsNextList}>
              <li>
                <span className={s.whatsNextItemIconWrapper}>
                  <Icon
                    component={MapTrifoldIcon}
                    fill="#65ADFF"
                    className={s.whatsNextItemIcon}
                    width="22px"
                    height="22px"
                  />
                </span>
                <Text type="brandon" className={s.whatsNextItem}>
                  From the <span className={s.whatsNextItemEmphasis}>Details tab,</span> review all imported events and
                  add any relevant content pages.
                </Text>
              </li>
              <li>
                <span className={s.whatsNextItemIconWrapper}>
                  <Icon
                    component={ImageIcon}
                    fill="#65ADFF"
                    className={s.whatsNextItemIcon}
                    width="22px"
                    height="22px"
                  />
                </span>
                <Text type="brandon" className={s.whatsNextItem}>
                  From the <span className={s.whatsNextItemEmphasis}>Itinerary tab,</span> don't forget to add photos to
                  bring your trip to life.
                </Text>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </AModal>
  );
};

const MagicImportCompletedModalFooter = (props: { submitForm: () => void }) => {
  return (
    <div>
      <Button onClick={props.submitForm} type="default" size="medium" htmlType="button">
        <div className={s.submitButton}>
          <Text type="brandon"> Got it</Text>
        </div>
      </Button>
    </div>
  );
};
